<div  class="text-center component-container">
  <div class="flx-container">
    <div class="flx-item">

      <h1 class="display-2">{{ title }}</h1>
    </div>

    <div class="flx-break"></div>

    @if (message) {
      <div class="flx-item">
        xx{{ message }}
      </div>
    }
  </div>

</div>